import { ElmFrameworkPorts } from "../../ElmFrameworkPorts";

export { handleOpenNewTab };

const MULTI_WATCHER_SESSION_KEY = "multiwatcher_sessions";

function handleOpenNewTab(appPorts: ElmFrameworkPorts) {
  appPorts.openNewTab?.subscribe((url: string) => {
    window.open(url, "_blank");
  });

  appPorts.clearSessionStorage?.subscribe(() => {
    sessionStorage.removeItem("user_id");
    sessionStorage.removeItem("watcher_session");
    sessionStorage.removeItem(MULTI_WATCHER_SESSION_KEY);
  });

  appPorts.storeUserId?.subscribe((userId: string) => {
    sessionStorage.setItem("user_id", userId);
    sessionStorage.removeItem("broker_id");
    sessionStorage.removeItem("watcher_session");
    sessionStorage.removeItem(MULTI_WATCHER_SESSION_KEY);
  });

  appPorts.storeBrokerSession?.subscribe((brokerId: string) => {
    sessionStorage.setItem("broker_id", brokerId);
    sessionStorage.removeItem("user_id");
    sessionStorage.removeItem("watcher_session");
    sessionStorage.removeItem(MULTI_WATCHER_SESSION_KEY);
  });

  appPorts.clearBrokerSession?.subscribe(() => {
    sessionStorage.removeItem("broker_id");
  });

  appPorts.storeWatcherSession?.subscribe((watcherSession: string) => {
    sessionStorage.setItem("watcher_session", watcherSession);
    sessionStorage.removeItem("user_id");
    sessionStorage.removeItem("broker_id");
    sessionStorage.removeItem(MULTI_WATCHER_SESSION_KEY);
  });
}
